import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Sentry } from '@stylehaven/components';
import 'replaywebpage';
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { environment } from './environments/environment';

// Initialize sentry
new Sentry(environment);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(BootstrapModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
